import { startOfYear, subDays, getMonth, getYear } from 'date-fns';

export const STATS_PRESETS = {
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_90_DAYS: 'LAST_90_DAYS',
  YTD: 'YTD',
  FISCAL_YEAR: 'FISCAL_YEAR',
  CUSTOM: 'CUSTOM',
};

/**
 * Calculates the start and end dates based on a preset.
 * @param {string} preset One of STATS_PRESETS
 * @param {Date} now Current date (optional, for testing)
 * @returns {Object} { startDate: Date, endDate: Date }
 */
export const getStatsDateRange = (preset, now = new Date()) => {
  let startDate;
  let endDate = now;

  switch (preset) {
    case STATS_PRESETS.LAST_30_DAYS:
      startDate = subDays(now, 30);
      break;
    case STATS_PRESETS.LAST_90_DAYS:
      startDate = subDays(now, 90);
      break;
    case STATS_PRESETS.YTD:
      startDate = startOfYear(now);
      break;
    case STATS_PRESETS.FISCAL_YEAR: {
      const currentYear = getYear(now);
      const currentMonth = getMonth(now); // 0-indexed, Oct is 9
      if (currentMonth >= 9) {
        // Oct, Nov, Dec: FY started Oct 1st of current year
        startDate = new Date(currentYear, 9, 1);
      } else {
        // Jan-Sep: FY started Oct 1st of previous year
        startDate = new Date(currentYear - 1, 9, 1);
      }
      break;
    }
    default:
      startDate = subDays(now, 30);
  }

  return { startDate, endDate };
};
